export default function SystemsDiagram({ className = "" }) {
  return (
    <svg
      data-testid="hero-systems-diagram"
      viewBox="0 0 480 440"
      fill="none"
      className={className}
      role="img"
      aria-label="Diagram: Strategy at the center, Product and Systems as the two primary disciplines, AI as an enabling layer supporting both"
    >
      {/* concentric strategy layers */}
      <circle cx="240" cy="176" r="150" stroke="#0F172A" strokeOpacity="0.06" />
      <circle cx="240" cy="176" r="104" stroke="#0F172A" strokeOpacity="0.09" />

      {/* primary paths: PRODUCT -> STRATEGY -> SYSTEMS */}
      <path
        d="M136 176 L 186 176"
        stroke="#0F172A"
        strokeOpacity="0.35"
        strokeWidth="1.5"
        className="dash-flow"
      />
      <path
        d="M294 176 L 344 176"
        stroke="#0F172A"
        strokeOpacity="0.35"
        strokeWidth="1.5"
        className="dash-flow"
      />

      {/* enabling layer: AI supports both */}
      <path
        d="M108 214 C 120 300, 180 344, 212 352"
        stroke="#C86D3B"
        strokeOpacity="0.5"
        strokeDasharray="3 7"
      />
      <path
        d="M372 214 C 360 300, 300 344, 268 352"
        stroke="#C86D3B"
        strokeOpacity="0.5"
        strokeDasharray="3 7"
      />

      {/* travelling signal across the primary chain */}
      <circle r="4" fill="#C86D3B">
        <animateMotion
          dur="6s"
          repeatCount="indefinite"
          path="M96 176 L 384 176"
        />
      </circle>

      {/* central philosophy */}
      <circle cx="240" cy="176" r="54" fill="#0F172A" />
      <circle cx="240" cy="176" r="54" stroke="#C86D3B" strokeOpacity="0.6" strokeDasharray="2 5" />
      <text
        x="240"
        y="180"
        textAnchor="middle"
        fill="#FAF8F5"
        fontSize="11"
        letterSpacing="3"
        style={{ fontFamily: "'JetBrains Mono', monospace" }}
      >
        STRATEGY
      </text>

      {/* primary disciplines */}
      {[
        { cx: 96, label: "PRODUCT", ly: 246 },
        { cx: 384, label: "SYSTEMS", ly: 246 },
      ].map((n) => (
        <g key={n.label}>
          <circle cx={n.cx} cy="176" r="40" fill="#FAF8F5" stroke="#0F172A" strokeOpacity="0.35" strokeWidth="1.5" />
          <circle cx={n.cx} cy="176" r="6" fill="#0F172A" className="pulse-dot" />
          <text
            x={n.cx}
            y={n.ly}
            textAnchor="middle"
            fill="#0F172A"
            fontSize="11"
            letterSpacing="3"
            style={{ fontFamily: "'JetBrains Mono', monospace" }}
          >
            {n.label}
          </text>
        </g>
      ))}

      {/* enabling layer node */}
      <circle cx="240" cy="356" r="28" fill="#FDF6F0" stroke="#C86D3B" strokeOpacity="0.8" strokeDasharray="4 4" />
      <circle cx="240" cy="356" r="5" fill="#C86D3B" className="pulse-dot" />
      <text
        x="240"
        y="410"
        textAnchor="middle"
        fill="#C86D3B"
        fontSize="10"
        letterSpacing="2.5"
        style={{ fontFamily: "'JetBrains Mono', monospace" }}
      >
        AI · ENABLING LAYER
      </text>
    </svg>
  );
}
